import { createSlice } from "@reduxjs/toolkit";
import { fpGroupState, seriesStore } from "../extra/createState";

export const selectSeriesList = ({ seriesSlice }) => seriesSlice.seriesList;
export const selectSeriesPart = ({ seriesSlice }) =>
  seriesSlice.selectSeriesPart;
export const selectSelectSeriesField = ({ seriesSlice }) =>
  seriesSlice.selectSeriesField;
export const selectTotalCount = ({ seriesSlice }) => seriesSlice.totalCounts;
export const selectCheckedState = ({ seriesSlice }) => seriesSlice.checkedState;
export const selectActiveSeries = ({ seriesSlice }) => seriesSlice.activeSeries;
export const selectShowType = ({ seriesSlice }) => seriesSlice.showType;
export const selectAmountType = ({ seriesSlice }) => seriesSlice.amountType;
export const selectLowAmountValue = ({ seriesSlice }) => seriesSlice.lowAmountValue;
export const selecUpdateMultiValuechange = ({ seriesSlice }) => seriesSlice.updateMultiValuechange
export const selectUpdateDefaultValueFlage = ({ seriesSlice }) => seriesSlice.updateDefalutValueFlag
export const selectCheckAll = ({ seriesSlice }) => seriesSlice.checkAll;
export const selectUpdateCheckedValue = ({ seriesSlice }) => seriesSlice.updateCheckedValue
export const selectFpGroupState = ({ seriesSlice }) => seriesSlice.fpGroupState
export const selectShowLastwinCardIndex = ({ seriesSlice }) => seriesSlice.showLastwinCardIndex
export const selectLoaderShow = ({ seriesSlice }) => seriesSlice.loaderShow
export const selectResetValue = ({ seriesSlice }) => seriesSlice.resetValue
export const selectResetHVInput = ({ seriesSlice }) => seriesSlice.resetHVInput
export const selectAdvaceTimeSlotCount = ({ seriesSlice }) => seriesSlice.advaceTimeSlotCount
export const selectMulti = ({ seriesSlice }) => seriesSlice.multi
export const selectTimeSlot = ({ seriesSlice }) => seriesSlice.selectTimeSlot


window.seriesStore = seriesStore
const seriesSlice = createSlice({
  name: "seriesSlice",
  initialState: {
    seriesList: [...seriesStore],
    selectSeriesPart: 0,
    selectSeriesField: 0,
    totalCounts: new Array(10)
      .fill()
      .map((u) => ({ totalCount: 0, totalValue: 0 })),
    checkedState: new Array(10).fill(false),
    activeSeries: new Array(10).fill(false),
    showType: "All",
    amountType: "Low",
    lowAmountValue: 2,
    updateMultiValuechange: [],
    updateDefalutValueFlag: false,
    checkAll: false,
    updateCheckedValue: false,
    fpGroupState: fpGroupState,
    showLastwinCardIndex: 0,
    loaderShow: false,
    resetValue: 0,
    advaceTimeSlotCount: 0,
    multi: false,
    resetHVInput: 0,
    selectTimeSlot: []
  },
  reducers: {
    setSeriesPart: (state, action) => {
      state.selectSeriesPart = action.payload;
    },
    setTotalCount: (state, action) => {
      let totalCounts = [...state.totalCounts];

      action.payload.map((number, index) => {
        let x = 0;
        state.seriesList[number].seriesAllfield.map((v, k) => {
          v.forEach((number, index) => {
            x += Number(number.getValue());
          });

          if (state.amountType === 'High') {
            totalCounts[number].totalValue =
              x * state.seriesList[number].multiply;
          } else {
            totalCounts[number].totalValue =
              x * (state.lowAmountValue)
          }
          totalCounts[number].totalCount = x;
        });
      });

      state.totalCounts = totalCounts;
    },
    updateCheckState: (state, action) => {
      state.checkedState = action.payload;
    },
    checkAll: (state, action) => {
      state.checkAll = true
      state.checkedState = new Array(10).fill(true);
    },
    resetCheckState: (state, action) => {
      state.checkAll = false
      state.checkedState = new Array(10).fill(false);
    },
    // activeSeries
    updateActiveSeries: (state, action) => {
      state.activeSeries = action.payload;
    },
    checkAllActiveSeries: (state, action) => {
      state.activeSeries = new Array(10).fill(true);
    },
    resetActiveSeries: (state, action) => {
      state.activeSeries = new Array(10).fill(false);
    },
    updateShowType: (state, action) => {
      state.showType = action.payload;
    },
    updateAmountType: (state, action) => {
      state.amountType = action.payload;
    },
    updateLowAmountValue: (state, action) => {
      state.lowAmountValue = action.payload;
    },
    resetInputValue: (state, action) => {
      let { totalAmount, amountType, printFlag } = action.payload
      let seriesList = action.payload.seriesList
      seriesList.map((count, index) => {
        if (totalAmount[index].totalCount > 0) {
          [1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((number, numberIndex) => {
            for (let inputIndex = 0; inputIndex < 100; inputIndex++) {
              seriesList[index].seriesAllfield[numberIndex][inputIndex].setValue(null)
            }
          })
        }
      })
      state.seriesList = seriesList
      state.totalCounts = new Array(10)
        .fill()
        .map((u) => ({ totalCount: 0, totalValue: 0 }))
      if (!printFlag) {
        state.selectSeriesPart = 0
        state.selectSeriesField = 0
        state.activeSeries = [...[true, false, false, false, false, false, false, false, false, false]]
        state.resetValue = state.resetValue + 1
      }
      state.resetHVInput = state.resetHVInput + 1

      state.checkedState = new Array(10).fill(false)
      state.showType = "All"
      state.amountType = amountType || 'High'
      state.lowAmountValue = 2
      state.updateMultiValuechange = []
      state.updateDefalutValueFlag = false
      state.checkAll = false
      state.updateCheckedValue = false
      state.fpGroupState = fpGroupState
      state.showLastwinCardIndex = 0
      state.activeSeries = [...[true, false, false, false, false, false, false, false, false, false]]

    },
    setUpdateMultiValuechange: (state, action) => {
      state.updateMultiValuechange = action.payload
    },
    resetSeriezValue: (state, action) => {
      let { index } = action.payload
      let totalAmount = JSON.parse(JSON.stringify(action.payload.totalAmount))
      // [...action.payload.totalAmount]

      let seriesList = [...action.payload.seriesList];
      // 
      [1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((number, numberIndex) => {
        for (let inputIndex = 0; inputIndex < 100; inputIndex++) {
          seriesList[index].seriesAllfield[numberIndex][inputIndex].setValue(null)
        }
      })
      totalAmount[index].totalCount = 0
      totalAmount[index].totalValue = 0
      state.seriesList = [...seriesList]
      state.totalCounts = [...totalAmount]

    },

    setDefaultValueFlag: (state, action) => {
      state.updateDefalutValueFlag = action.payload
    },
    setUpdateCheckedValue: (state, action) => {
      state.updateCheckedValue = action.payload
    },
    setShowLastwinCardIndex: (state, action) => {
      state.showLastwinCardIndex = action.payload
    },
    setLoaderShow: (state, action) => {
      state.loaderShow = action.payload
    },
    setAdvanceTimeSlotCount: (state, action) => {
      state.advaceTimeSlotCount = action.payload
    },
    setMulti: (state, action) => {
      state.multi = action.payload
    },

    setSelectTimeSlot: (state, action) => {
      state.selectTimeSlot = action.payload
    }



  },
  extraReducers: {
    // set getmenu api response
  },
});

// this is for dispatch

// this is for configureStore
export default seriesSlice.reducer;

export const {
  setSeriesPart,
  setTotalCount,
  updateCheckState,
  resetCheckState,
  checkAll,
  updateActiveSeries,
  checkAllActiveSeries,
  resetActiveSeries,
  updateShowType,
  updateAmountType,
  updateLowAmountValue,
  resetInputValue,
  setUpdateMultiValuechange,
  resetSeriezValue,
  setDefaultValueFlag,
  setUpdateCheckedValue,
  setShowLastwinCardIndex,
  setLoaderShow,
  setAdvanceTimeSlotCount,
  setMulti,
  setSelectTimeSlot
} = seriesSlice.actions;
